export const COLORS = {
  imageBackground: '#ccc',
  secondaryButtonBackground: 'rgba(220,220,220,0.5)',
  secondaryButtonHoverBackground: 'rgba(220,220,220,0.9)',
  primarySectionBackground: 'rgba(158,207,250,0.25)',
  secondarySectionBackground: 'rgba(220,220,220,0.2)',
  secondarySectionHoverBackground: 'rgba(220,220,220,0.3)',
  mediaControlsBackground: 'rgba(0, 0, 0, 0.5)',
  secondaryIcon: 'rgba(0, 0, 0, 0.5)',
  placehoder: '#808080',
  lightBlue: '#0085FF',
  darkBlue: '#213f68',
  darkGray: '#808080',
  primary: '#2684ff',
  secondary: '#fea92c',
  content: '#202020',
}

export const SHADOWS = {
  default: '0 0 10px 0 rgba(128, 128, 128, 0.1)',
  hover: '0 2px 8px 0 rgb(99 99 99 / 20%)',
}
